<div class="login_popup" id="exampleModalToggle" aria-hidden="true" aria-labelledby="exampleModalToggleLabel"
    tabindex="-1" *ngIf="isLoginPopup">
    <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
            <div class="modal-header">
                <img src="/assets/icons/header/legalStack.svg" alt="">
                <button type="button" class="btn-close" (click)="closePopup()"></button>
            </div>
            <div class="modal-body">
                <section class="login_tabs">
                    <div class="container">
                        <div class="col-lg-12">
                            <div class="login_welcome">
                                <p>Login to continue to your LegalStack account</p>
                                <div class="login_trust">
                                    <span><i class="fa-solid fa-circle-check"></i> 1L+ Users</span>
                                    <span><i class="fa-solid fa-star"></i> 4.9 Rated</span>
                                    <span><i class="fa-solid fa-lock"></i> 100% Secure</span>
                                </div>
                            </div>
                            <ul class="nav nav-tabs">
                                <li class="nav-item">
                                    <a class="nav-link first-child" data-bs-toggle="tab" href="#login"
                                        [ngClass]="loginPopuptype=='login'?'active':''">Login</a>

                                </li>
                                <!-- <li class="nav-item">
                                    <a class="nav-link" data-bs-toggle="tab" href="#signup" [ngClass]="loginPopuptype=='signUp'?'active':''">Signup</a>
                                </li> -->
                            </ul>
                            <div class="tab-content">

                                <div id="login" class="tab-pane" [ngClass]="loginPopuptype=='login'?'active':''">
                                    <div class="tab-content">
                                        <div class="tab-content_login">
                                            <div class="mobileFlagDiv" *ngIf="gS.indiaTimezone ">
                                                <form [formGroup]="phoneForm" (ngSubmit)="requestOtpFlag()"
                                                    class="mobileForm" [class.d-none]="showOtpFields">
                                                    <ngx-intl-tel-input [cssClass]="'form-control'"
                                                        [preferredCountries]="preferredCountries"
                                                        customPlaceholder="Enter your mobile number" 
                                                        [enablePlaceholder]="true" 
                                                        [onlyCountries]="['in', 'us']"
                                                        [separateDialCode]="true"
                                                        [enableAutoCountrySelect]="true"
                                                        [enablePlaceholder]="true" 
                                                        [searchCountryFlag]="true"
                                                        [searchCountryField]="[SearchCountryField.Name, SearchCountryField.DialCode, SearchCountryField.Iso2]"
                                                        [selectFirstCountry]="false"
                                                        [selectedCountryISO]="CountryISO.India" [maxLength]="10"
                                                        formControlName="phone">
                                                    </ngx-intl-tel-input>

                                                    <div class="terms" *ngIf="!showOtpFields">
                                                        <label>
                                                            <input type="checkbox" formControlName="termsAccepted" />
                                                            <span>
                                                                <span>I agree to the <a href="/terms" target="_blank"> Terms and
                                                                    Conditions</a> and </span><a href="/privacy" target="_blank">
                                                                Privacy Policy</a></span>
                                                            
                                                        </label>
                                                    </div>

                                                    <button type="submit" *ngIf="!showOtpFields"
                                                        [disabled]="!phoneForm.valid || !phoneForm.value.termsAccepted">Submit</button>
                                                </form>


                                                <form *ngIf="showOtpFields" (ngSubmit)="submitLogin()"
                                                    class="otpflagForm">
                                                    <div class="otp-info">
                                                        <div class="otp-info-icon">
                                                            <i class="fa-solid fa-comment-sms"></i>
                                                        </div>
                                                        <h3 class="otp-info-title">Verify your mobile number</h3>
                                                        <p class="otp-info-sub">
                                                            Enter the 4-digit OTP sent to
                                                            <strong>{{ phoneForm?.value?.phone?.internationalNumber || phoneForm?.value?.phone?.e164Number }}</strong>
                                                        </p>
                                                        <button type="button" class="otp-change"
                                                            (click)="changeNumber()">
                                                            <i class="fa-solid fa-pen"></i> Change number
                                                        </button>
                                                    </div>

                                                    <div class="otp-container">
                                                        <input type="text" [(ngModel)]="otp[0]" name="otp1"
                                                            maxlength="1" required class="otp-input" placeholder="–" #otp1
                                                            (input)="gS.moveToNext(otp1, otp2)" />
                                                        <input type="text" [(ngModel)]="otp[1]" name="otp2"
                                                            maxlength="1" required class="otp-input" placeholder="–" #otp2
                                                            (input)="gS.moveToNext(otp2, otp3)"
                                                            (keydown.backspace)="gS.moveToPrev(otp2, otp1)" />
                                                        <input type="text" [(ngModel)]="otp[2]" name="otp3"
                                                            maxlength="1" required class="otp-input" placeholder="–" #otp3
                                                            (input)="gS.moveToNext(otp3, otp4)"
                                                            (keydown.backspace)="gS.moveToPrev(otp3, otp2)" />
                                                        <input type="text" [(ngModel)]="otp[3]" name="otp4"
                                                            maxlength="1" required class="otp-input" placeholder="–" #otp4
                                                            (keydown.backspace)="gS.moveToPrev(otp4, otp3)" />
                                                    </div>

                                                    <div class="resentPassword">
                                                        <p *ngIf="countdown > 0" class="countDownn"> Resend OTP in {{ countdown }}s</p>
                                                        <p *ngIf="showResend" (click)="requestOtpagain()" class="resentpass">Resend OTP ?</p>
                                                    </div>
                                                    <button type="submit" class="otpsubmitbtn"
                                                        [disabled]="otp.join('').length !== 4">Verify OTP</button>
                                                </form>
                                            </div>


                                            <!-- Email Login Form -->
                                            <form *ngIf="!gS.indiaTimezone" class="emailForm"
                                            [formGroup]="emailForm" (ngSubmit)="submitEmailLogin()">
                                                <!-- Email Input -->
                                                <div class="form_input" *ngIf="!showEmailOtpField">
                                                    <input type="email" class="form-control" formControlName="email"
                                                        placeholder="Enter your email"  id="email"  />

                                                        <div class="terms" >
                                                            <label>
                                                                <input type="checkbox" formControlName="termsAccepted" />
                                                                <span>
                                                                    <span>I agree to the <a href="/terms" target="_blank"> Terms and
                                                                        Conditions</a> and </span><a href="/privacy" target="_blank">
                                                                    Privacy Policy</a></span>
                                                                
                                                            </label>
                                                        </div>

                                                    <!-- <button type="button" class="btn btn-login"
                                                        *ngIf="!showEmailOtpField" (click)="submitEmailLogin()">
                                                        Login
                                                    </button> -->

                                                    <button type="submit" *ngIf="!showEmailOtpField"
                                                        [disabled]="!emailForm.valid || !emailForm.value.termsAccepted">Submit</button>
                                                </div>

                                                <!-- OTP Fields -->
                                               
                                            </form>

                                            <form class="emailotp">
                                                <div *ngIf="showEmailOtpField">

                                                    <div class="notes">Note: If you don’t see our email in your inbox within a few minutes, please check your Spam or Junk folder. To ensure you receive future updates, add us to your safe sender list or mark the email as “Not Spam.”</div>
                                                    <div class="otpsent">OTP Sent to
                                                        {{emailForm?.value?.email}}
                                                    </div>

                                                    <div class="otp-container">
                                                        <input type="text" maxlength="1" [(ngModel)]="emailOtp[0]"
                                                            name="otp1" #otp1 (input)="gS.moveToNext(otp1, otp2)"
                                                            required class="otp-input" placeholder="–" />
                                                        <input type="text" maxlength="1" [(ngModel)]="emailOtp[1]"
                                                            name="otp2" #otp2 (input)="gS.moveToNext(otp2, otp3)"
                                                            (keydown.backspace)="gS.moveToPrev(otp2, otp1)" required
                                                            class="otp-input" placeholder="–" />
                                                        <input type="text" maxlength="1" [(ngModel)]="emailOtp[2]"
                                                            name="otp3" #otp3 (input)="gS.moveToNext(otp3, otp4)"
                                                            (keydown.backspace)="gS.moveToPrev(otp3, otp2)" required
                                                            class="otp-input" placeholder="–" />
                                                        <input type="text" maxlength="1" [(ngModel)]="emailOtp[3]"
                                                            name="otp4" #otp4
                                                            (keydown.backspace)="gS.moveToPrev(otp4, otp3)" required
                                                            class="otp-input" placeholder="–" />
                                                    </div>

                                                  

                                                    <div class="resentPassword">
                                                        <p *ngIf="countdown > 0" class="countDownn"> Resend OTP in {{ countdown }}</p>
                                                        <p *ngIf="showResend" (click)="resendOTPEmail()" class="resentpass">Resend OTP ?</p>
                                                    </div>


                                                    <button type="submit" (click)="submitEmailOtp()" class="btn btn-login"
                                                        [disabled]="emailOtp.join('').length !== 4">
                                                        Verify OTP
                                                    </button>
                                                </div>
                                            </form>

                                            <div class="login_bottom_hint" *ngIf="!showOtpFields && !showEmailOtpField">
                                                <span class="hint_icon"><i class="fa-solid fa-wand-magic-sparkles"></i></span>
                                                <p>
                                                    <span *ngIf="gS.indiaTimezone">Just enter your <strong>mobile number</strong> — we'll
                                                        <strong>log you in</strong> or <strong>create your account</strong> instantly.</span>
                                                    <span *ngIf="!gS.indiaTimezone">Just enter your <strong>email</strong> — we'll
                                                        <strong>log you in</strong> or <strong>create your account</strong> instantly.</span>
                                                </p>
                                            </div>

                                            <div class="secure_note">
                                                <i class="fa-solid fa-shield-halved"></i>
                                                <span>Your information is safe &amp; encrypted</span>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                                <div id="signup" class="tab-pane" [ngClass]="loginPopuptype=='signUp'?'active':''">
                                    <div class="tab-content">
                                        <div class="tab-content_login">
                                            <form>
                                                <div class="form_input">
                                                    <input type="name" class="form-control" id="exampleInputName1"
                                                        aria-describedby="nameHelp" placeholder="Name">
                                                </div>
                                                <div class="form_input">
                                                    <input type="email" class="form-control" id="exampleInputEmail1"
                                                        aria-describedby="emailHelp" placeholder="Email">
                                                </div>
                                                <div class="mb-3">
                                                    <input type="password" class="form-control"
                                                        id="exampleInputPassword1" placeholder="Password">
                                                </div>
                                                <button type="submit" class="btn btn-login">Signup</button>
                                            </form>

                                            <div class="or">
                                                <p>OR</p>
                                            </div>

                                            <div class="social">
                                                <button><img src="/assets/icons/modals/google.svg" alt="">Continue with
                                                    Google</button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </section>
            </div>
        </div>
    </div>
</div>


<div class="login_popup" id="exampleModalToggleResetPass" aria-hidden="true" aria-labelledby="exampleModalToggleLabel"
    tabindex="-1" *ngIf="isForgetPassPopup">
    <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
            <div class="modal-header">
                <img src="/assets/icons/header/legalStack.svg" alt="">
                <button type="button" class="btn-close" (click)="closePopup()"></button>
            </div>
            <div class="modal-body">
                <h2 class="heading">Reset Password</h2>
                <p class="text">Enter the email address associated with your account <br>
                    and we’ll send you a link to reset your password.</p>

                <div class="mt-3">
                    <input type="email" class="form-control" id="exampleInputEmail1" aria-describedby="emailHelp"
                        placeholder="Your Email">
                </div>
                <div class="alert">
                    <img src="/assets/icons/modals/alert.svg" alt="">
                    <label class="form-alert-label">Please enter a valid email address.</label>
                </div>

                <div class="mb-3 success">
                    <img src="/assets/icons/modals/right_icon.svg" alt="">
                    <label class="form-success-label">A link to reset password has been <br>
                        successfully sent on your registered email.</label>
                </div>

                <button type="submit" class="btn btn-login" (click)="otpPopup()">Submit</button>
            </div>
        </div>
    </div>
</div>


<div class="login_popup" id="exampleModalToggleOtp" aria-hidden="true" aria-labelledby="exampleModalToggleLabel"
    tabindex="-1" *ngIf="isOtpPopup">
    <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
            <div class="modal-header">
                <img src="/assets/icons/header/legalStack.svg" alt="">
                <button type="button" class="btn-close" (click)="closePopup()"></button>
            </div>
            <div class="modal-body">
                <section class="otp_form">
                    <h1 class="title">Enter OTP to verify email</h1>
                    <form id="otp-form">
                        <input type="text" class="otp-input" placeholder="–" maxlength="1">
                        <input type="text" class="otp-input" placeholder="–" maxlength="1">
                        <input type="text" class="otp-input" placeholder="–" maxlength="1">
                        <input type="text" class="otp-input" placeholder="–" maxlength="1">
                    </form>
                    <p class="text">
                        Not Received? <a href="#" class="resend">Resend OTP</a>
                    </p>

                    <button id="verify-btn" (click)="closePopup()">Verify Email</button>
                </section>
            </div>
        </div>
    </div>
</div>